export const selectSindromeAnalisis = (state) =>
  state.holonmed.sindromeAnalisis;
